module.exports = __webpack_public_path__ + "img/Handy_mit-Screen_Eigene_App_Neu.154a3f51.png";